import { formatDate, parseISODuration } from '@utils';
import { SUBSCRIPTIONS_STATUSES } from '@constants';
import theme from 'config/theme';

export const getHumanReadableDuration = (iso8601duration) => {
  if (!iso8601duration) return '-';
  const parsedDuration = parseISODuration(iso8601duration, true);
  const { years, months } = parsedDuration;

  let result = years ? `${years * 12 + (months || 0)} Months` : '';
  if (!result && months) {
    result = `${months} Month${months > 1 ? 's' : ''}`;
  }
  return result || '-';
};

export const formatSubscriptionOption = (subscription) => {
  const vehicleBrand = subscription.vehicle?.manufacturer || '';
  const vehicleModel = subscription.vehicle?.model || '';
  const vehicleName = `${vehicleBrand} ${vehicleModel}`.trim() || '-';
  const plate = subscription.vehiclePlate || subscription.vehicle?.plate || '';
  const statusText = SUBSCRIPTIONS_STATUSES[subscription.status] || '-';
  const createdAt = subscription.createdAt
    ? formatDate(subscription.createdAt, 'dd-MM-yyyy')
    : '-';
  const estimatedDuration =
    subscription.rules?.[subscription.rules.length - 1]?.estimatedDuration;
  const plan = getHumanReadableDuration(estimatedDuration);

  return {
    value: subscription.id,
    id: subscription.id,
    text: `${vehicleName} - ${plate} - ${statusText}`,
    display: `${vehicleName} | ${plate} | ${statusText} | ${createdAt} | ${plan}`,
    label: `${vehicleName} - ${plate}`,
    subscription,
  };
};

export const formatBookingOption = (booking) => {
  const bookingId = booking?.id || '';
  const vehicleTitle = booking?.vehicle?.title || '-';
  const vehicleStatus = booking?.is_active || '';
  const vehiclePlate = booking?.vehicleDetails?.plate || '';
  const vehicleStage = booking?.stage;
  return {
    id: bookingId,
    title: vehicleTitle,
    status: vehicleStatus,
    plate: vehiclePlate,
    stage: vehicleStage,
    booking,
  };
};

export const formatUserOption = (user) => ({
  value: user.id,
  id: user.id,
  display: `${user.email || ''} - ${user.firstName || ''} ${
    user.lastName || ''
  } - ${user.phoneNumber || ''}`,
  text: `${user.firstName || ''} ${user.lastName || ''} - ${
    user.email || ''
  } - ${user.phoneNumber || ''}`,
  label: user.name || user.email || '',
  user,
});

export const getSubscriptionStatusColor = (status) => {
  if ([2, 3, 4].includes(status)) {
    return {
      border: theme.palette.greens.green200,
      color: theme.palette.greens.green900,
      dot: theme.palette.greens.green400,
    };
  }
  if ([1, 5].includes(status)) {
    return {
      border: theme.palette.oranges.orange200,
      color: theme.palette.oranges.orange900,
      dot: theme.palette.oranges.orange400,
    };
  }
  if ([6, 8].includes(status)) {
    return {
      border: theme.palette.reds.red200,
      color: theme.palette.reds.red900,
      dot: theme.palette.reds.codingRed400,
    };
  }
  return {
    border: theme.palette.grays.gray300,
    color: theme.palette.grays.gray600,
    dot: theme.palette.grays.gray300,
  };
};

export const getSearchableText = (option) =>
  [
    String(option.id ?? '').toLowerCase(),
    String(option.title ?? '').toLowerCase(),
    String(option.plate ?? '').toLowerCase(),
  ]
    .filter(Boolean)
    .join(' ');
